import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const AddProductModal = ({ open, onOpenChange, suppliers, sectorLabel, onSave }) => {
  const [name, setName] = useState("");
  const [cond, setCond] = useState("");
  const [supplierKey, setSupplierKey] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setName("");
      setCond("");
      setSupplierKey(suppliers?.[0]?.key || "");
    }
  }, [open, suppliers]);

  const submit = async () => {
    if (!name.trim() || !supplierKey) return;
    setSaving(true);
    await onSave({ name: name.trim(), cond: cond.trim(), supplier_key: supplierKey });
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-3xl bg-card border-border">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-extrabold">Ajouter un produit</DialogTitle>
          <DialogDescription className="text-muted-foreground">
            Secteur {sectorLabel}. Aucun prix demandé ici — il reste géré dans l'Excel.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-1">
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Nom du produit</Label>
            <Input
              data-testid="product-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="ex : Bière artisanale IPA"
              className="mt-1.5 h-12 rounded-xl bg-secondary border-border"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Fournisseur</Label>
            <Select value={supplierKey} onValueChange={setSupplierKey}>
              <SelectTrigger data-testid="product-supplier-select" className="mt-1.5 h-12 rounded-xl bg-secondary border-border">
                <SelectValue placeholder="Choisir un fournisseur" />
              </SelectTrigger>
              <SelectContent className="bg-popover border-border max-h-72">
                {(suppliers || []).map((s) => (
                  <SelectItem key={s.key} value={s.key}>{s.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Conditionnement</Label>
            <Input
              data-testid="product-cond-input"
              value={cond}
              onChange={(e) => setCond(e.target.value)}
              placeholder="ex : 75cl, Carton 24, Fût 30L…"
              className="mt-1.5 h-12 rounded-xl bg-secondary border-border"
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            data-testid="save-product-btn"
            onClick={submit}
            disabled={saving || !name.trim() || !supplierKey}
            className="rounded-xl font-bold px-6 active:scale-95 transition-transform"
          >
            {saving ? "Ajout…" : "Ajouter"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
